import React from "react";

// Subtle 360-inspired ring mark
export function Logo360({ size = 36, className = "" }) {
  return (
    <div className={`relative inline-flex items-center justify-center ${className}`} style={{ width: size, height: size }}>
      <svg viewBox="0 0 100 100" className="absolute inset-0" fill="none">
        <circle cx="50" cy="50" r="44" stroke="#C9B896" strokeWidth="4" />
        <circle cx="50" cy="6" r="5" fill="#B8A99A" />
      </svg>
      <span className="font-serif font-semibold text-brand-anthracite" style={{ fontSize: size * 0.3 }}>
        360
      </span>
    </div>
  );
}

export function Wordmark({ compact = false }) {
  return (
    <div className="flex items-center gap-3" data-testid="app-wordmark">
      <Logo360 size={compact ? 34 : 40} />
      <div className="leading-tight">
        <div className="font-serif text-lg font-semibold text-brand-anthracite">360 Nails</div>
        {!compact && <div className="text-[11px] uppercase tracking-[0.18em] text-brand-taupe">Price Calculator</div>}
      </div>
    </div>
  );
}
